module.exports = __webpack_public_path__ + "static/media/pfbg_1200.04bbcd23.jpg";